export function getContentProps({ insurance, productTypeName, primaryProductName, primaryProductImageId, urls }, insuranceId, provider) {
    return {
        insuranceProduct: insurance ? getInsuranceProductById(insurance, insuranceId) : undefined,
        primaryProductName,
        primaryProductImageId,
        productTypeName,
        provider,
        urls,
    };
}
export function getExtendedWarrantiesContentProps({ insurance, primaryProductName, primaryProductImageId, urls }, insuranceId) {
    return {
        insuranceProduct: insurance ? getInsuranceProductById(insurance, insuranceId) : undefined,
        insuranceDescription: (insurance === null || insurance === void 0 ? void 0 : insurance.description) || '',
        primaryProductName,
        primaryProductImageId,
        urls,
    };
}
export function getInsuranceProductById(insurance, insuranceId) {
    let selectedInsuranceProduct = undefined;
    for (const insurancePackage of insurance.packages) {
        const insuranceProduct = insurancePackage.products.find(insuranceProduct => insuranceProduct.id === insuranceId);
        if (insuranceProduct) {
            selectedInsuranceProduct = insuranceProduct;
            break;
        }
    }
    return selectedInsuranceProduct;
}
//# sourceMappingURL=getContentProps.js.map